export class SqsQueuePolicyProbeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "queueUrl",
            "baseName": "queueUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SqsQueuePolicyProbeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
